const belgianPublicHolidayKeyCache = new Map<number, Set<string>>();

const formatDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const addDays = (date: Date, days: number) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
};

const getEasterSunday = (year: number) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
};

const getBelgianPublicHolidayKeys = (year: number) => {
  const cachedKeys = belgianPublicHolidayKeyCache.get(year);

  if (cachedKeys) {
    return cachedKeys;
  }

  const easterSunday = getEasterSunday(year);
  const holidayKeys = new Set([
    `${year}-01-01`,
    formatDateKey(addDays(easterSunday, 1)),
    `${year}-05-01`,
    formatDateKey(addDays(easterSunday, 39)),
    formatDateKey(addDays(easterSunday, 50)),
    `${year}-07-21`,
    `${year}-08-15`,
    `${year}-11-01`,
    `${year}-11-11`,
    `${year}-12-25`,
  ]);

  belgianPublicHolidayKeyCache.set(year, holidayKeys);

  return holidayKeys;
};

export const isBelgianPublicHoliday = (date: Date) => {
  return getBelgianPublicHolidayKeys(date.getFullYear()).has(formatDateKey(date));
};
